import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectNotificationsOverrideStatusFragment = { __typename?: 'Project', id: string, hasProjectNotificationsOverride?: boolean | null };

export const ProjectNotificationsOverrideStatus = /*#__PURE__*/ gql`
    fragment ProjectNotificationsOverrideStatus on Project {
  id
  hasProjectNotificationsOverride
}
    ` as unknown as DocumentNode<ProjectNotificationsOverrideStatusFragment, unknown>;

        

        
export const useProjectNotificationsOverrideStatusFragment = (
  input: string | Omit<UseFragmentOptions<ProjectNotificationsOverrideStatusFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectNotificationsOverrideStatusFragment>({
    fragment: ProjectNotificationsOverrideStatus,
    fragmentName: 'ProjectNotificationsOverrideStatus',
    ...options,
  });
};
  
        